export default __webpack_public_path__ + "static/media/img-aboutbanner-draft.7593c49f.jpg";